export const browserStorageKeys = {
  openOnAppPagePath: 'openOnAppPagePath',
  storedPageForRedirection: 'storedPageForRedirection',
} as const;

export type browserStorageKeyType = keyof typeof browserStorageKeys;
